
(function(){
  if (window.__almGalVar) return;
  window.__almGalVar = 1;

  var node = document.getElementById('alm-galvar-data');
  if (!node) return;
  var D;
  try { D = JSON.parse(node.textContent); } catch (e) { return; }
  if (!D || !D.images || D.images.length < 2 || !D.options || !D.options.length) return;

  function slug(s){
    s = String(s == null ? '' : s).toLowerCase();
    if (s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
    return s.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  /* Table des valeurs d'option : slug -> index d'option + libelle exact */
  var BY_SLUG = {};
  D.options.forEach(function (o, oi) {
    (o.values || []).forEach(function (v) {
      var k = slug(v);
      if (k) BY_SLUG[k] = { oi: oi, value: v };
    });
  });

  var byId = {};
  D.images.forEach(function (im) { im.tags = {}; byId[im.id] = im; });

  var tagged = false;

  /* 1. tags explicites #valeur dans le texte alternatif */
  D.images.forEach(function (im) {
    var found = String(im.alt || '').match(/#[^\s#,;.]+/g);
    if (!found) return;
    found.forEach(function (t) {
      var hit = BY_SLUG[slug(t.slice(1))];
      if (!hit) return;
      im.tags[hit.oi] = hit.value;
      tagged = true;
    });
  });

  /* 2. repli automatique : image mise en avant d'une variante.
     Condition d'activation : TOUTES les variantes doivent avoir une image assignee.
     Si une seule n'en a pas, on ne devine rien -- une image rattachee a une variante
     isolee ferait disparaitre a tort les images de ses voisines.
     Une option n'est taguee que si elle est constante parmi les variantes qui
     partagent cette image : sur un produit Finition x Interrupteur ou la meme photo
     sert aux deux interrupteurs, seule la finition est retenue. */
  var vlist = D.variants || [];
  var toutesOntUneImage = vlist.length > 0 && vlist.every(function (v) { return v.image != null; });
  if (toutesOntUneImage) {
    var featured = {};
    vlist.forEach(function (v) {
      (featured[v.image] = featured[v.image] || []).push(v);
    });
    Object.keys(featured).forEach(function (id) {
      var im = byId[id];
      if (!im) return;
      var vs = featured[id];
      D.options.forEach(function (o, oi) {
        if (im.tags[oi] != null) return;            /* un tag ecrit a la main l'emporte */
        if (!o.values || o.values.length < 2) return;
        var val = vs[0].options[oi];
        var same = vs.every(function (v) { return v.options[oi] === val; });
        if (!same) return;
        im.tags[oi] = val;
        tagged = true;
      });
    });
  }

  if (!tagged) return; /* aucune image rattachee a une variante : aucun filtre */

  var wrap = document.querySelector('[class*="mz-main-img-wrap-"]');
  if (!wrap) return;

  var wrapSel = '[class*="mz-main-img-wrap-"]';
  if (wrap.id) {
    try { wrapSel = '#' + (window.CSS && CSS.escape ? CSS.escape(wrap.id) : wrap.id); }
    catch (e) { wrapSel = '[class*="mz-main-img-wrap-"]'; }
  }
  var IMG = wrapSel + ' > img[class*="mz-main-img-"]';

  /* Les URL d'origine des images, relevees avant tout changement de variante.
     La section embarque un correctif (almVariantImage) qui, 1,25 s apres un clic de
     variante, reecrit le src de la PREMIERE image de la galerie avec la photo de la
     variante : la grande image de tete etait remplacee par une photo deja presente
     plus bas, en double. Ce correctif faisait office de filtre du pauvre ; il est
     rendu inutile par le filtrage et on remet donc chaque image sur sa propre source. */
  var GAL = [].slice.call(wrap.querySelectorAll('img[class*="mz-main-img-"]'));
  var SRC = GAL.map(function (im) { return im.getAttribute('data-src') || im.getAttribute('src'); });
  try {
    var srcGuard = new MutationObserver(function (recs) {
      for (var i = 0; i < recs.length; i++) {
        var el = recs[i].target;
        var k = GAL.indexOf(el);
        if (k < 0 || !SRC[k]) continue;
        if (el.getAttribute('src') !== SRC[k] && !el.getAttribute('data-src')) {
          el.removeAttribute('srcset');
          el.setAttribute('src', SRC[k]);
        }
      }
    });
    GAL.forEach(function (im) { srcGuard.observe(im, { attributes: true, attributeFilter: ['src'] }); });
  } catch (e) {}

  /* 03/09 — POURQUOI ON NE REECRIT PLUS LA FEUILLE DE STYLE EN MOBILE.
     Mesure sur la fiche (6 274 elements, 96 feuilles, 7 065 regles) : toute
     reecriture d'une feuille force un recalcul de style de TOUTE la page,
     140 ms. apply() etait appele 3 fois par clic de couleur (observateur +
     0 ms + 120 ms) : 3 x 140 ms de blocage, c'est ce que Lancelot voyait comme
     « ca met du temps a changer ». Desormais :
       - une regle FIXE, posee une seule fois ;
       - en mobile on bascule une classe sur les 20 images (recalcul limite a
         ces elements, < 5 ms) ;
       - la mosaique desktop (>= 1100 px) garde ses regles de grille par rang,
         mais la feuille n'est reecrite que si son contenu change. */
  var sheet = document.createElement('style');
  sheet.id = 'alm-galvar-css';
  document.head.appendChild(sheet);
  var fixe = document.createElement('style');
  fixe.id = 'alm-galvar-fixe';
  fixe.textContent = IMG + '.alm-galvar-hide{display:none!important}\n' +
    '.nty-thumbstrip__btn.alm-galvar-hide,[class*="mz-thumb-"].alm-galvar-hide,[class*="mz-dot-"].alm-galvar-hide{display:none!important}\n';
  document.head.appendChild(fixe);
  var mqDesktop = window.matchMedia ? window.matchMedia('(min-width:1100px)') : null;
  var derniereCss = '';
  var dernierEtat = '';

  function selectedValues(){
    var sel = {};
    var btns = document.querySelectorAll('[class*="mz-variant-btn-"].active, [class*="mz-color-swatch-"].active');
    for (var i = 0; i < btns.length; i++) {
      var oi = parseInt(btns[i].getAttribute('data-option-index'), 10);
      var val = btns[i].getAttribute('data-value');
      if (!isNaN(oi) && val != null) sel[oi] = val;
    }
    return sel;
  }

  function visibleIndexes(){
    var sel = selectedValues();
    var vis = [];
    D.images.forEach(function (im) {
      var keep = true;
      for (var oi in im.tags) {
        if (!Object.prototype.hasOwnProperty.call(im.tags, oi)) continue;
        if (sel[oi] != null && sel[oi] !== im.tags[oi]) keep = false;
      }
      if (keep) vis.push(im.i);
    });
    return vis;
  }

  function basculer(sel, i, cache) {
    var els = document.querySelectorAll(sel + '[data-index="' + i + '"]');
    for (var k = 0; k < els.length; k++) els[k].classList.toggle('alm-galvar-hide', cache);
  }

  function apply(){
    var vis = visibleIndexes();
    var tout = !vis.length || vis.length === D.images.length;
    var etat = tout ? 'tout' : vis.join(',');
    var desktop = mqDesktop ? mqDesktop.matches : false;

    if (etat !== dernierEtat) {
      dernierEtat = etat;
      var shown = {};
      vis.forEach(function (i) { shown[i] = 1; });
      var imgs = wrap.querySelectorAll('img[class*="mz-main-img-"]');
      D.images.forEach(function (im) {
        var cache = !tout && !shown[im.i];
        if (imgs[im.i]) imgs[im.i].classList.toggle('alm-galvar-hide', cache);
        basculer('.nty-thumbstrip__btn', im.i, cache);
        basculer('[class*="mz-thumb-"]', im.i, cache);
        basculer('[class*="mz-dot-"]', im.i, cache);
      });
    }

    /* mosaique >= 1100 px : les positions de grille suivent le rang VISIBLE.
       v2 2026-08-19 : le rang 2 recopie AUSSI height/object-fit — le theme ne les
       pose que sur la position DOM 2 ; sans cela une image DOM > 2 placee au rang 2
       restait carree et laissait un trou sous elle. */
    var css = '';
    if (!tout && desktop) {
      var total = vis.length;
      css += '@media (min-width:1100px){\n';
      vis.forEach(function (idx, rank) {
        var s = IMG + ':nth-of-type(' + (idx + 1) + ')';
        if (total === 1) {
          css += s + '{grid-column:1/-1!important;grid-row:auto!important;aspect-ratio:4/3!important}\n';
        } else if (rank === 0) {
          css += s + '{grid-column:6/span 7!important;grid-row:auto!important;aspect-ratio:1/1!important}\n';
        } else if (rank === 1) {
          css += s + '{grid-column:1/span 5!important;grid-row:1!important;aspect-ratio:auto!important;height:100%!important;width:100%!important;object-fit:cover!important;align-self:stretch!important;min-height:0!important}\n';
        } else if (rank === 2 && total === 3) {
          css += s + '{grid-column:1/-1!important;grid-row:auto!important;aspect-ratio:16/9!important}\n';
        } else {
          css += s + '{grid-column:span 4!important;grid-row:auto!important;aspect-ratio:1/1!important}\n';
        }
      });
      css += '}\n';
    }
    if (css !== derniereCss) { derniereCss = css; sheet.textContent = css; }

    if (tout) return;

    /* en dessous de 1100 px une seule image est affichee a la fois : si c'est une image
       filtree, on demande a la section d'afficher la premiere image restee visible. */
    setTimeout(function () {
      /* 03/09 : on RECALCULE la selection ici. Avant, la fermeture gardait la liste
         calculee 40 ms plus tot ; si la selection avait change entre-temps, on
         cliquait un point MASQUE et le carrousel repartait a l'image 1. */
      var visNow = visibleIndexes();
      if (!visNow.length || visNow.length === D.images.length) return;
      var first = visNow[0];
      var imgs = wrap.querySelectorAll('img[class*="mz-main-img-"]');
      for (var k = 0; k < visNow.length; k++) {
        var el = imgs[visNow[k]];
        if (el && getComputedStyle(el).display !== 'none') return;
      }
      var d = document.querySelector('[class*="mz-dot-"][data-index="' + first + '"]');
      if (d) { d.click(); return; }
      var t = document.querySelector('.nty-thumbstrip__btn[data-index="' + first + '"]');
      if (t) t.click();
    }, 40);
  }
  if (mqDesktop && mqDesktop.addEventListener) { mqDesktop.addEventListener('change', function () { apply(); }); }

  /* declencheurs */
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    if (!t.closest('[class*="mz-variant-btn-"],[class*="mz-color-swatch-"]')) return;
    setTimeout(apply, 0);
    setTimeout(apply, 120);
  }, true);

  window.addEventListener('popstate', function () { setTimeout(apply, 0); });

  try {
    var mo = new MutationObserver(function () { apply(); });
    var btns = document.querySelectorAll('[class*="mz-variant-btn-"],[class*="mz-color-swatch-"]');
    for (var i = 0; i < btns.length; i++) {
      mo.observe(btns[i], { attributes: true, attributeFilter: ['class'] });
    }
  } catch (e) {}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  setTimeout(apply, 600);
  setTimeout(apply, 1800);
})();
